import React from 'react';
import { AboutStyle,ImageBackStyle } from './styles';

export default function About()
{
    return(
        <>
            <AboutStyle>
                <ImageBackStyle/>
            </AboutStyle>
        </>
    )
}